import { ServicesService } from '../../services/services.service';
import { Service } from '../../models/service.model';
import { PageEvent } from '@angular/material/paginator';
import { UtilsService } from '../../services/utils.service';
import { PaginatorStatus, DataTableColumn, SortConfiguration } from '../generics/data-table/data-table.component';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CustomTableFilter } from '../generics/table-filter/table-filter.component';
import { ErrorResponse } from 'src/app/models/error.model';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Producto', prop: 'tipoProducto', sortable: true, type: 'text' },
        { name: 'Código', prop: 'codigo', sortable: true },
        { name: 'Servicio', prop: 'nombre', sortable: true },
        { name: 'Descripción', prop: 'descripcion', sortable: true },
        { name: 'Porcentaje', prop: 'porcentajeDefault', sortable: true, type: 'percent' },
        { name: 'Tope mínimo', prop: 'topeMinimoDefault', sortable: true, type: 'money' },
        { name: 'Tope máximo', prop: 'topeMaximoDefault', sortable: true, type: 'money' },
        { name: 'Depende de', prop: 'pagador', sortable: true },
        { name: '', width: '140px' }
    ];

    sortConfiguration?: SortConfiguration;

    services: Service[] = [];

    filters: CustomTableFilter[] = [
        { key: 'nombre', description: 'Nombre de servicio', type: 'STRING' },
        { key: 'codigo', description: 'Código', type: 'STRING' },
    ];
    filterValues: any = {};

    constructor(
        private servicesService: ServicesService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getServices();
    }

    getServices() {

        this.servicesService.getServices(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], this.filterValues)
            .subscribe(response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.services = response.body;
            }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener servicios', error.error?.descripcion));

    }

    updateServices(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getServices();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getServices();
    }

    deleteService(service: Service) {
        const dialog = this.utilsService.confirm('¿Está seguro?', 'Esta acción no se puede deshacer.');
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.servicesService.deleteService(service.id).subscribe(_ => {
                    this.utilsService.alert('Servicio eliminado correctamente', `Se ha eliminado el servicio ${service.nombre} de la plataforma.`);
                    this.getServices();

                }, (error: ErrorResponse) => this.utilsService.alert('Error al eliminar el servicio', error.error?.descripcion));
            }
        });
    }


    setFilterValues(values: any) {
        this.filterValues = values;
        this.getServices();
    }

}
